import { useLanguage } from "@/i18n/LanguageContext";

const Dot = () => (
  <svg viewBox="0 0 24 24" className="mx-6 h-3.5 w-3.5 shrink-0 text-brand/60" fill="none" stroke="currentColor" strokeWidth="1.6">
    <circle cx="12" cy="12" r="8.6" />
    <path d="M12 7.2l3 2.2-1.15 3.5h-3.7L9 9.4l3-2.2z" fill="currentColor" stroke="none" />
  </svg>
);

export const EditorialMarquee = () => {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee];

  return (
    <div data-testid="teamup-editorial-marquee" className="marquee overflow-hidden border-y border-white/5 py-7">
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
            {items.map((item, i) => (
              <span key={`${copy}-${i}`} className="flex items-center">
                <span className="whitespace-nowrap font-display text-2xl font-bold uppercase tracking-tight text-white/[0.13] transition-colors duration-500 hover:text-brand/70 sm:text-3xl md:text-4xl">
                  {item}
                </span>
                <Dot />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
